export default "__VITE_ASSET__RZ3pOacY__"